// extracted by mini-css-extract-plugin
export default {"publicBadgeContainer":"publicBadge_publicBadgeContainer__tz1e4","publicBadgeContainer__badgeSkeleton":"publicBadge_publicBadgeContainer__badgeSkeleton__HUKMv"};